import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { EyeIcon, HeadphonesIcon, MicIcon } from 'lucide-react';
export function MethodSection() {
  const features = [{
    icon: EyeIcon,
    title: 'Nivel 1 - Visual',
    description: 'Ves la pregunta en inglés y su traducción exacta en español al mismo tiempo, creando un ancla visual que tu cerebro no olvida.'
  }, {
    icon: HeadphonesIcon,
    title: 'Nivel 2 - Auditivo',
    description: 'Escuchas la pregunta como la haría un oficial real, con el acento, la velocidad y el tono exacto de una entrevista real.'
  }, {
    icon: MicIcon,
    title: 'Nivel 3 - Respuesta',
    description: 'Practicas tu respuesta en voz alta durante los silencios del audio, exactamente como lo tendrás que hacer el día de tu entrevista.'
  }];
  return <section className="w-full bg-[#1B2A4A] text-white" data-id="element-149">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-24" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-151">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6 text-center" data-id="element-152">
            El Método que Sí Funciona: Traducción Espejo y Anclaje Visual
          </h2>

          <div className="max-w-3xl mx-auto text-center space-y-4 mb-12" data-id="element-153">
            <p className="text-lg text-gray-200" data-id="element-154">
              Después de analizar casos reales de entrevistas del último año,
              identificamos el patrón exacto de por qué personas preparadas
              siguen fallando.
            </p>
            <p className="text-lg text-gray-200" data-id="element-155">
              La razón es simple: memorizan respuestas pero nunca entrenan su
              cerebro para responder bajo presión en inglés.
            </p>
            <p className="text-xl font-semibold text-[#C9A84C]" data-id="element-156">
              Por eso creamos el Método de Traducción Espejo y Anclaje Visual.
              Un sistema que trabaja en tres niveles simultáneos:
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-157">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white/10 backdrop-blur-sm p-6 rounded-lg border-2 border-[#C9A84C]" data-id="element-158">
                <feature.icon className="w-12 h-12 text-[#C9A84C] mb-4" data-id="element-159" />
                <h3 className="text-xl font-bold mb-3 text-[#C9A84C]" data-id="element-160">
                  {feature.title}
                </h3>
                <p className="text-gray-200" data-id="element-161">{feature.description}</p>
              </motion.div>)}
          </div>

          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="text-2xl text-center font-bold text-white" data-id="element-162">
            Este triple entrenamiento convierte el pánico en confianza en tiempo
            récord.
          </motion.p>
        </motion.div>
      </div>
    </section>;
}